var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"only-company"},[_c('vs-checkbox',{model:{value:(_vm.onlyCompanies),callback:function ($$v) {_vm.onlyCompanies=$$v},expression:"onlyCompanies"}},[_vm._v("Only Companies")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }